module.exports = __webpack_public_path__ + "img/edit.5d1e66fe.svg";